import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";

export const DialogBox = ({ controller }) => (
  <Dialog
    open={controller.open}
    onClose={controller.handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">
      {controller.title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
        {controller.message}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {controller.type === "confirm" && <Button variant="outlined" onClick={controller.handleCancel}>Não</Button>}
      <Button
        variant="contained"
        color={controller.type === "confirm" ? "secondary" : "primary"}
        onClick={controller.handleConfirm}
      >
        {controller.type === "confirm" ? "Sim" : "OK"}
      </Button>
    </DialogActions>
  </Dialog>
);
